import { render, staticRenderFns } from "./DynamicSection.vue?vue&type=template&id=66d34e6f&scoped=true"
import script from "./DynamicSection.vue?vue&type=script&lang=js"
export * from "./DynamicSection.vue?vue&type=script&lang=js"
import style0 from "./DynamicSection.vue?vue&type=style&index=0&id=66d34e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d34e6f",
  null
  
)

export default component.exports